import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import MediaCard from "./MediaCard";

export default function MediaRow({ title, items, rowKey, showProgress = false }) {
  const ref = useRef(null);
  if (!items || items.length === 0) return null;
  const scroll = (dir) => {
    if (!ref.current) return;
    // One "page" slide: fewer cards per click, smoother feel with free scroll
    const amount = dir * Math.max(320, ref.current.clientWidth * 0.6);
    ref.current.scrollBy({ left: amount, behavior: "smooth" });
  };
  return (
    <section className="relative py-6 md:py-8" data-testid={`media-row-${rowKey}`}>
      <div className="px-4 md:px-8 lg:px-12 flex items-baseline gap-3 mb-3">
        <h2 className="text-xl md:text-2xl font-serif">{title}</h2>
        <span className="text-xs text-[#D1CFC9]/60 font-bold tracking-widest uppercase">{items.length}</span>
      </div>
      <div className="relative group">
        <button
          onClick={() => scroll(-1)}
          className="hidden md:grid absolute left-2 top-1/2 -translate-y-1/2 z-20 w-11 h-11 rounded-full bg-black/70 backdrop-blur place-items-center opacity-70 group-hover:opacity-100 transition-[opacity,background-color,color] hover:bg-[#978D78] hover:text-[#0F1829] shadow-lg"
          aria-label="Anterior"
          data-testid={`media-row-${rowKey}-prev`}
        >
          <ChevronLeft />
        </button>
        <div
          ref={ref}
          className="flex gap-4 overflow-x-auto scrollbar-hide px-4 md:px-8 lg:px-12 pb-4 scroll-smooth"
          style={{ scrollBehavior: "smooth", scrollSnapType: "none", WebkitOverflowScrolling: "touch" }}
        >
          {items.map((it) => (
            <div key={it.ID_ConteudoMediaCenter} className="shrink-0">
              <MediaCard item={it} showProgress={showProgress} />
            </div>
          ))}
        </div>
        <button
          onClick={() => scroll(1)}
          className="hidden md:grid absolute right-2 top-1/2 -translate-y-1/2 z-20 w-11 h-11 rounded-full bg-black/70 backdrop-blur place-items-center opacity-70 group-hover:opacity-100 transition-[opacity,background-color,color] hover:bg-[#978D78] hover:text-[#0F1829] shadow-lg"
          aria-label="Seguinte"
          data-testid={`media-row-${rowKey}-next`}
        >
          <ChevronRight />
        </button>
      </div>
    </section>
  );
}
